import {UntypedFormArray} from '@angular/forms';

export function moveItemInFormArray(
  formArray: UntypedFormArray,
  fromIndex: number,
  toIndex: number,
): void {
  const dir = toIndex > fromIndex ? 1 : -1;
  const item = formArray.at(fromIndex);

  for (let i = fromIndex; i * dir < toIndex * dir; i = i + dir) {
    const current = formArray.at(i + dir);

    formArray.setControl(i, current);
  }

  formArray.setControl(toIndex, item);
}
